import { useState } from "react";
import { BsCameraVideo } from "react-icons/bs";
import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";

const Accordion = ({ title, info, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border">
      <button
        className="w-full text-left p-4 bg-gray-100 hover:bg-gray-200 font-medium flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>
          {isOpen ? (
            <RiArrowDropUpLine className="inline mr-2" />
          ) : (
            <RiArrowDropDownLine className="inline mr-2" />
          )}
          {title}
        </span>
        <span className="font-thin">{info} </span>
      </button>
      {isOpen && (
        <div className="p-4 border-t bg-white">
          {items?.map((item, index) => (
            <div
              key={index}
              className="w-full text-left p-1 font-thin flex justify-between items-center"
            >
              <span>
                <BsCameraVideo className="inline mr-2" /> {item?.title}
              </span>
              <span className="font-thin">{item?.length}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Accordion;
